import React from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import * as Sentry from "@sentry/react";
import {BrowserTracing} from "@sentry/tracing";
import _ from 'underscore';
import {runtime} from 'rest/runtime';
import App from './App';
import {supportedLocales} from 'i18n'
import UserService from './rest/services/UserService';

import Toastr from 'toastr2';
import 'toastr2/dist/toastr.min.css';

window.toastr = {};

const bootReactApp = () => {
  registerToastr();
  runtime.currentUser = new UserService(userData)

  const partner = runtime.currentUser.get('partner') == 3 ? 'voicetome' : 'voicearchive'
  let initialLocale = 'en'

  if (navigator && 'language' in navigator && typeof navigator.language === 'string') {
    const browserLocale = navigator.language.substring(0, 2)

    if (Object.keys(supportedLocales).includes(browserLocale)) {
      initialLocale = browserLocale
    }
  }

  if (app.ENVIRONMENT === 'PRODUCTION') {
    Sentry.init({
      dsn: 'https://36b5795569ec437e85d4f7168f7d98b3@sentry.io/25085',
      environment: app.ENVIRONMENT,

      integrations: [new BrowserTracing()],
      release: app.version,

      // We recommend adjusting this value in production, or using tracesSampler
      // for finer control
      tracesSampleRate: 1.0,
    });

    const userContext = (({uid, username, email, usergroup, labs, roles}) => ({
      uid,
      username,
      email,
      usergroup,
      labs,
      roles
    }))(runtime.currentUser.userData);

    // Check that user is logged in
    if (userContext['uid'] !== undefined) {
      Sentry.setUser(
        userContext
      )
    }
  }


  render(
    <App partner={partner} initialLocale={initialLocale}/>,
    document.getElementById('react_app')
  )
}

const registerToastr = () => {
  const toastr = new Toastr();
  window.toastr = toastr;
}

const destroyReactApp = () => {
  runtime.currentUser = undefined
  unmountComponentAtNode(document.getElementById('react_app'))
}

global._ = _

global.system = {
  bootReactApp,
  destroyReactApp,
  ...global.system,
};
